import type { IWorkspaceDB } from '../../../db/interface';
import type { IAuthenticationManager } from '../../../controller/interface';
import { injectSiteDataAPI } from '../../../api/interface/bind';
import { injectConfigAPI } from '../../../interface/config';
import type { IContainer } from '../../../interface/container';
import { injectProgressPromise } from '../../../interface/promise';
import updateSite from './updateSite';

function bind(
    container: IContainer,
): (name: string, db: IWorkspaceDB, auth: IAuthenticationManager) => ReturnType<typeof updateSite> {
    const configAPI = injectConfigAPI(container);
    const siteAPI = injectSiteDataAPI(container);
    const promiser = injectProgressPromise(container);
    return (name: string, db: IWorkspaceDB, auth: IAuthenticationManager) =>
        updateSite(configAPI, siteAPI, promiser, name, db, auth);
}

export default bind;
